import React from 'react';
import styled from "styled-components";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import {useWindowSize} from "@helpers/windows.size";
import RadiusGenerate from "@helpers/radius.generate";
import Avatar from "@atoms/avatar";
import ConvertPixelToRem from "@helpers/convert.rem";
import {isEmpty} from "@helpers/helpers";
import Skeleton from 'react-loading-skeleton';
import {getAvatar, getRealtorProfileUrl} from "@models/user";
import Icon from "@atoms/icon";
import VerifiedBadgeIcon from '@icons/verified-badge.svg';

function RealtorsSlider({realtors, className, freeMode = false}) {
    const windowSize = useWindowSize();
    const breakpoints = {
        1024: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 2.4,
        },
        320: {
            slidesPerView: 1.5,
        }
    };

    const fakeArray = [...Array(5)];

    return (
        <Container>
            <Carousel className={(className ? className : '')} breakpoints={breakpoints} pagination={false} navigation_show={(!isEmpty(realtors) && realtors.length > 4)}>
                {
                    (!isEmpty(realtors) && realtors.length) ?
                        realtors.map((realtor, key) => {
                            const paramForMakeUrl = {
                                realtor_city_name: realtor.city_name,
                                realtor_district_name: realtor.district_name,
                                realtor_slug: realtor.slug,
                                agency_name: realtor.agency_name,
                                fullName: realtor.fullName,
                                username: realtor.username
                            };

                            const realtorProfileUrl = getRealtorProfileUrl(paramForMakeUrl);

                            return (
                                <CarouselItem key={key}>
                                    <Card key={key} className="w-100 d-flex align-items-center flex-column text-center item-card">
                                        <a href={realtorProfileUrl} className="w-100">
                                            <Avatar src={getAvatar(!isEmpty(realtor) ? realtor.id : '')} size="80"/>

                                            <Name
                                                title={realtor.fullName}
                                                className="h4 mt-16 text-ellipsis w-100">{realtor.fullName}</Name>
                                        </a>

                                        <div className="d-flex align-items-center justify-content-center w-100">
                                            <Agency
                                                title={realtor.agency_name}
                                                className="font-weight-light text-ellipsis">
                                                {realtor.agency_name}
                                            </Agency>

                                            {
                                                (realtor.agency_authenticated) ?
                                                    <Icon width={14} height={14} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                                    : ''
                                            }

                                        </div>

                                        <a href={realtorProfileUrl} className="mt-16 btn btn-secondary btn-sm">نمایش پروفایل</a>
                                    </Card>
                                </CarouselItem>
                            )
                        })
                        :
                        fakeArray.map((item, key) =>
                            <CarouselItem key={key}>
                                <Card key={key} className=" text-center">
                                    <Skeleton height={(windowSize > 991 ? 88 : 64)} circle width={(windowSize > 991 ? 88 : 64)}/>

                                    <div className="mt-8">
                                        <Skeleton width="70%"/>
                                        <Skeleton width="85%"/>
                                    </div>

                                    <div className="mt-16">
                                        <Skeleton height={36} width="85%"/>
                                    </div>
                                </Card>
                            </CarouselItem>
                        )
                }
            </Carousel>
        </Container>
    )
}

export default React.memo(RealtorsSlider);
// styles
const Container = styled.div`
  .swiper-container {
    padding-bottom: 24px;
    margin-bottom: -24px;
  }
`;

const Name = styled.div`
  @media (max-width: ${props => props.theme.screenSmMax}) {
    font-size: ${ConvertPixelToRem(15)};
  }
`;

const Agency = styled.span`
  font-size: ${ConvertPixelToRem(14)};

  @media (max-width: ${props => props.theme.screenSmMax}) {
    font-size: ${ConvertPixelToRem(12)};
  }
`;

const Card = styled.div`
  padding: 24px 16px;
  ${RadiusGenerate('8px')};
  border: solid 1px ${props => props.theme.gray200};
  background-color: #ffffff;

  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.12);
  }

  img {
    background-color: ${props => props.theme.gray100};
  }

  .text-ellipsis {
    max-width: 100%;
  }
`;